/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ActionBarWidget", ["OverflowBarWidgetBase", "WidgetFactory"], function (context, cls) {
  /**
   * Horizontal bar of action commands that overflow into a "…" menu. Adds the WAI-ARIA toolbar +
   * menu-button semantics on top of the generic overflow engine of OverflowBarWidgetBase. Reusable
   * outside the layout tree (chromebar, table header, ring menu).
   * @class ActionBarWidget
   * @memberOf classes
   * @extends classes.OverflowBarWidgetBase
   * @publicdoc Widgets
   */
  cls.ActionBarWidget = context.oo.Class(cls.OverflowBarWidgetBase, function ($super) {
    return /** @lends classes.ActionBarWidget.prototype */ {
      __name: "ActionBarWidget",
      // Reuse the base bar template (structure + "…" trigger); only the ARIA semantics below differ.
      __templateName: "OverflowBarWidgetBase",

      // Toolbar + menu-button semantics (the rest is handled by the base engine).
      _barAriaRole: "toolbar",
      _popupRole: "menu", // → popup role + trigger aria-haspopup + style class gbc_ActionBarWidget__menu
      _overflowItemRole: "menuitem"
    };
  });
  cls.WidgetFactory.registerBuilder("ActionBar", cls.ActionBarWidget);
});
